import { useTranslation } from '@ies/intl-react-plugin';
import React, { useState } from 'react';
import BookCover from '../component/book-cover';
import { RankItem } from '../type';
import cs from 'classnames';

interface IProps {
    data: RankItem[];
    title: string;
}

const Panel: React.FC<IProps> = ({ data, title }) => {
    const { t } = useTranslation();
    const [hasShowDetail, setHasShowDetail] = useState(false);
    return (
        <div className="home-id-rank-panel">
            <h1>{title}</h1>
            <div className={cs('home-id-rank-content', { 'no-show-detail': !hasShowDetail })}>
                {data.map((item, index) => (
                    <div className="home-id-rank-item" key={index}>
                        <BookCover className="rank-book" url={item.image_url} isMobile />
                        <div className="rank-right">
                            <div className="rank-right-title">{item.title}</div>
                            <div className="rank-right-msg">
                                <img src={item.avatar} alt="" />
                                <span>{item.author}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {!hasShowDetail && (
                <div className="home-id-rank-show-detail" onClick={() => setHasShowDetail(true)}>
                    <div className="home-id-rank-show-detail-info">{t('detail_label')}</div>
                    <div className="home-id-rank-show-detail-icon" />
                </div>
            )}
        </div>
    );
};
export default Panel;
